import projects from './projects'
import project_tags from './project-tags'

const api = {
  items: projects,
  tags: project_tags,
}

export default api
